/* One accessible set of tabs, shared by touch, pointer and keyboard. */
if (!customElements.get('sxt-collection-tabs')) customElements.define('sxt-collection-tabs', class extends HTMLElement {
 connectedCallback() {
  if(this.ready)return; this.ready=true;
  this.tabs=Array.from(this.querySelectorAll('[role="tab"]'));
  this.panels=Array.from(this.querySelectorAll('.tab-item'));
  if(this.tabs.length!==this.panels.length)return;
  this.classList.add('sxt-tabs-ready');
  this.tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>this.select(i));
   tab.addEventListener('keydown',e=>{
    let next=i;
    if(e.key==='ArrowRight')next=(i+1)%this.tabs.length;
    else if(e.key==='ArrowLeft')next=(i+this.tabs.length-1)%this.tabs.length;
    else if(e.key==='Home')next=0;
    else if(e.key==='End')next=this.tabs.length-1;
    else return;
    e.preventDefault();this.select(next);this.tabs[next].focus();
   });
  });
  this.addEventListener('shopify:block:select',e=>{const i=this.panels.indexOf(e.target.closest('.tab-item'));if(i>=0)this.select(i);});
  this.select(0);
 }
 select(index) {
  this.panels.forEach((panel,i)=>{
   const active=i===index;
   panel.open=active;panel.hidden=!active;
   panel.setAttribute('role','tabpanel');
   panel.setAttribute('aria-labelledby',this.tabs[i].id);
   this.tabs[i].setAttribute('aria-selected',String(active));
   this.tabs[i].tabIndex=active?0:-1;
   this.tabs[i].classList.toggle('active',active);
  });
  window.dispatchEvent(new Event('resize'));
 }
});
